import React, { Component } from 'react';
import { connect } from 'react-redux';

import { LinkContainer } from 'react-router-bootstrap';
import { Panel, Col, Row } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import * as FicheActions from 'redux/modules/fiches';
/*
import {isLoaded as areFichesLoaded, load as loadFiches} from 'redux/modules/fiches';
import {isLoaded as areGroupsLoaded, load as loadGroups} from 'redux/modules/groups';*/

import { analyseState } from 'utils/analyseState';



import { SyncProductsTable } from 'components';

import _ from 'underscore';

import './MobileDashboard.css';

var elevator = require('../../../static/img/elevator.png')
var escalator = require('../../../static/img/escalator.png')


import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({
    products: state.products.data,
    user: state.auth.user,
    dashboardOptions: state.fiches.dashboardOptions
  }),
  dispatch => bindActionCreators({ ...FicheActions }, dispatch)
)
export default class ResumePanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      openPannes: false,
      openDisactivated: false,
      openSync: false,
      openTravaux: false,
      openProducts: false,
      openUsagers: false,
      openColumn:false

    };

    this.openPanel = this.openPanel.bind(this);
  }

  componentWillUnmount() {

  }


  openPanel(panel) {


    var obj = {
      openProducts: false,
      openDisactivated: false,
      openTravaux: false,
      openPannes: false,
      openUsagers: false,
      openCyclical: false,
    }

    obj[panel] = !this.state[panel]

    //this.setState({ openColumn:obj[panel] ? panel : false })     

    _.each(obj, (v, k) => {
      if (panel == k) {
        this.props.setDashboardOptions(k, !this.props.dashboardOptions[k].open)
      } else {
        this.props.setDashboardOptions(k, false)
      }
    })


  }



  render() {

    const {t} = this.props

    var products = this.props.products || [];

    var {
      openProducts, openUsagers,
      openPannes, openDisactivated,
      openTravaux, openCyclical } = this.props.dashboardOptions;

    var syncTable = [];
    var pannesTable = [];
    var unfinishedTable = [];
    var disactivatedTable = [];
    var travauxTable = [];

    var cyclicalTable = [];

    var productTable = [];
    var requiredFields = [/*'identification_GSM', */'identification_NUM_ASC', 'identification_ID', 'localisation_adresse']

    var usager_products = []


    _.each(products, function (p) {


      if ((p.identification_fosse < 1 || p.identification_fosse == null)) {

        var s_etat = analyseState(p.s_etat)

        if (_.where(p.timeline_rows, { type: 'usager', end_code: null }).length > 0) {
          usager_products.push(p)
        }


        productTable.push(p)



        var row =
          <div>
            <LinkContainer to={'/client/product/' + p.id + '/edit'}>
              <button className="btn btn-primary">
                {t('main.product')+ ' ' + p.id}  <i className="fa fa-pencil" />
              </button>
            </LinkContainer><br />
          </div>


        for (var j = 0; j < requiredFields.length; j++) {
          var field = requiredFields[j];
          if (p[field] == '') {
            var style = 'warning';
            unfinishedTable.push(p);
            break;
          }
        }


        if (p.etat_indisponibilite_sts == 1) {
          disactivatedTable.push(p)
        } else {

          if (p.last_cyclical_row && p.last_cyclical_row.call_type != 'CO') {
            cyclicalTable.push(p)
          }
        }

        if (p.etat_en_panne == 1) {
          pannesTable.push(p)
        }

        if (p.etat_en_travaux == 1) {
          travauxTable.push(p)
        }

      } else {

        if (p.last_cyclical_row && p.etat_indisponibilite_sts == 0 && p.last_cyclical_row.call_type != 'CO') {
          cyclicalTable.push(p)
        }



      }

    })

    /*
    var header1 =
      <div onClick={() => syncTable.length > 0 && this.openPanel('openSync')}
        style={{
          'cursor': 'pointer', position: "absolute",
          'bottom': '-15px', 'right': 10,
          'fontSize': '13px'
        }}
        className="panel-heading" >


        <div className="row">
          <div className="col-xs-3">
            <i className="fa fa-exchange fa-4x"></i>
          </div>
          <div className="col-xs-9 text-right" style={{ height: '100px' }}>
            <h3 >Fiches STS ({syncTable.length})</h3>

            {syncTable.length > 0 &&
              <div >
                {!this.state.openSync ? t("main.open") : t("main.close")}
              </div>
            }
          </div>
        </div>
      </div>
*/


    var header2 =
      <div onClick={() => {
        if (pannesTable.length > 0) {
          this.openPanel('openPannes');
               
        } 
      }} className="panel-heading" >
        <div className="row">
          <div className="col-xs-3">
            <i className="fa fa-warning fa-4x"></i>
          </div>
          <div className="col-xs-9 text-right" style={{ height: '100px' }}>
            <h3 > {t('resume_panel.pannes_install')}  {genHeader(pannesTable, t)}</h3>

            {pannesTable.length > 0 &&
              <div style={{ cursor: 'pointer', position: "absolute", 'bottom': '-15px', 'right': 10, 'fontSize': '13px' }}>
                {!openPannes.open ? t("main.open") : t("main.close")}
              </div>
            }

          </div>
        </div>
      </div>


    var header4 =
      <div onClick={() => {
        if (disactivatedTable.length > 0) {
          this.openPanel('openDisactivated');        
        } }} className="panel-heading">
        <div className="row">
          <div className="col-xs-3">
            <i className="fa fa-minus-circle fa-4x"></i>
          </div>
          <div className="col-xs-9 text-right" style={{ height: '100px' }}>
            <h3 >{t('resume_panel.indispo_sts')} {genHeader(disactivatedTable, t)}</h3>

            {disactivatedTable.length > 0 &&
              <div style={{ cursor: 'pointer', position: "absolute", 'bottom': '-15px', 'right': 10, 'fontSize': '13px' }}>
                {!openDisactivated.open ? t("main.open") : t("main.close")}
              </div>
            }

          </div>
        </div>
      </div>



    var header5 =
      <div onClick={() => {

        if (productTable.length > 0) {
          this.openPanel('openProducts');
        }
         
      }} className="panel-heading">
        <div className="row" style={{ height: "100px" }}>
          <div style={{ float: 'left' }}>
            <img width="60" src={elevator} title="Ascenseur" /> &nbsp;<img width="60" title="Escalier mécanique" src={escalator} />
          </div>
          <div style={{ float: 'right' }} >
            <h3 > {productTable.length} {t('resume_panel.sts_sheets')}</h3>

            {productTable.length > 0 &&
              <div style={{ cursor: 'pointer', position: "absolute", 'right': "32px", 'fontSize': '13px' }} >
                {!products.open ? t('main.open'): t('main.close')}
              </div>
            }
          </div>
        </div>
      </div>



    var header7 =
      <div onClick={() => {
        if (travauxTable.length > 0) {
          this.openPanel('openTravaux') ;
        } }} className="panel-heading">
        <div className="row">
          <div className="col-xs-3">
            <i className="fa fa-wrench fa-4x"></i>
          </div>
          <div className="col-xs-9 text-right">
            <h3 >{t('resume_panel.travaux_install')} {genHeader(travauxTable, t)}</h3>

            {travauxTable.length > 0 &&
              <div style={{ cursor: 'pointer', position: "absolute", 'bottom': '-15px', 'right': 10, 'fontSize': '13px' }}>
                {!openTravaux.open ? t('main.open') : t('main.close')}
              </div>
            }

          </div>
        </div>
      </div>


    var header8 = (

      <div onClick={() => {
        if (usager_products.length > 0) {
          this.openPanel('openUsagers');
        }
      }} className="panel-heading" >
        <div className="row">
          <div className="col-xs-3">
            <i className="fa fa-warning fa-4x"></i>
          </div>
          <div className="col-xs-9 text-right" style={{ height: '100px' }}>
            <h3 >{t('resume_panel.blocked_users')} {genHeader(usager_products, t)}</h3>

            {usager_products.length > 0 &&
              <div style={{ cursor: 'pointer', position: "absolute", 'bottom': '-15px', 'right': 10, 'fontSize': '13px' }}>
                {!openUsagers.open ? t('main.open') : t('main.close')}
              </div>
            }

          </div>
        </div>
      </div>)


  var header9 = (

    <div onClick={() => {
      if (cyclicalTable.length > 0) {
        this.openPanel('openCyclical');
      }
    }} className="panel-heading" >
          <div className="row">
            <div className="col-xs-3">
              <i className="fa fa-refresh fa-4x"></i>
            </div>
            <div className="col-xs-9 text-right" style={{ height: '100px' }}>
              <h3>{t('resume_panel.cyclical_default')} {genHeader(cyclicalTable, t)}</h3>

              {cyclicalTable.length > 0 &&
                <div style={{ cursor: 'pointer', position: "absolute", 'bottom': '-15px', 'right': 10, 'fontSize': '13px' }}>
                  {/*!openCyclical.open ? t("main.open") : t("main.close")*/}
                </div>
              }

            </div>
          </div>
        </div>)

    /*var colSize

    var CO_COUNT = _.where(cyclicalTable, { 'last_call_type': 'CO' }).length;
    var CK_COUNT = _.where(cyclicalTable, { 'last_call_type': 'CK' }).length;
    var CN_COUNT = _.where(cyclicalTable, { 'last_call_type': 'CN' }).length;*/

    // Créez des objets de mappage pour les colonnes
    const headerMap = {
      openProducts: header5,
      openPannes: header2,
      openUsagers: header8,
      openDisactivated: header4,
      openTravaux: header7,
      openCyclical: header9
    };

    const tableMap = {
      openProducts: productTable,
      openPannes: pannesTable,
      openUsagers: usager_products,
      openDisactivated: disactivatedTable,
      openTravaux: travauxTable,
      openCyclical: cyclicalTable
    };

    const bsStyleMap = {
      openProducts: 'primary',
      openPannes: 'danger',
      openUsagers: 'danger',
      openDisactivated: 'warning',
      openTravaux: 'warning',
      openCyclical: 'warning'
    };

    const typeMap = {
      openProducts: 'normal',
      openPannes: 'pannes',
      openUsagers: 'usager',
      openDisactivated: 'indisponible',
      openTravaux: 'travaux',
      openCyclical: 'cyclical'
    };

      
    var arrayPanels = [
      { bsStyle:'primary', name: 'openProducts', label: header5, table: productTable },
      { bsStyle:'danger', name: 'openPannes', label: header2, table: pannesTable },
      { bsStyle:'danger', name: 'openUsagers', label: header8, table: usager_products },
      { bsStyle:'warning', name: 'openDisactivated', label: header4, table: disactivatedTable },
      { bsStyle:'warning', name: 'openTravaux', label: header7, table: travauxTable },
      { bsStyle:'warning', name: 'openCyclical', label: header9, table: cyclicalTable }
    ]

    // Créez un tableau d'ordre par défaut pour les colonnes
    const defaultColumnOrder = [
      'openProducts',
      'openPannes',
      'openUsagers',
      'openDisactivated',
      'openTravaux',
      'openCyclical'
    ];
    var openColumn = false


    // Déterminez la colonne ouverte
    //const openColumn = Object.entries(this.props.dashboardOptions).filter((k,v)=>v.open).length ? Object.entries(this.props.dashboardOptions).filter((k,v)=>v.open)

    // Triez les colonnes en fonction de la colonne ouverte ou de l'ordre par défaut
    const sortedColumns = defaultColumnOrder.sort((a, b) => {

      if (Object.values(this.props.dashboardOptions).filter(o=>o.open).length > 0 ) {
        // Si une colonne est ouverte, placez-la en premier
        if (a === openColumn) return -1;
        if (b === openColumn) return 1;
      }
      // Appliquez l'ordre par défaut si aucune colonne n'est ouverte
      return defaultColumnOrder.indexOf(a) - defaultColumnOrder.indexOf(b);
    });

    // --- Mobile : grille d'indicateurs + liste en cartes de l'indicateur sélectionné ---
    const mobileTiles = [
      { name: 'openPannes', icon: 'fa-warning', label: t('resume_panel.pannes_install'), alert: 'red' },
      { name: 'openUsagers', icon: 'fa-user-times', label: t('resume_panel.blocked_users'), alert: 'red' },
      { name: 'openDisactivated', icon: 'fa-minus-circle', label: t('resume_panel.indispo_sts'), alert: 'orange' },
      { name: 'openTravaux', icon: 'fa-wrench', label: t('resume_panel.travaux_install'), alert: 'orange' },
      { name: 'openCyclical', icon: 'fa-refresh', label: t('resume_panel.cyclical_default'), alert: 'orange' },
      { name: 'openProducts', icon: 'fa-building-o', label: t('resume_panel.sts_sheets'), alert: null },
    ];
    const mobileOpen = _.find(mobileTiles, (tile) => this.props.dashboardOptions[tile.name].open);

    return (

      <div>

        <div className="visible-xs-block mobile-dashboard">
          <div className="mobile-kpi-grid">
            {mobileTiles.map((tile) => {
              const count = tableMap[tile.name].length;
              const level = count > 0 && tile.alert ? tile.alert : (tile.alert ? 'ok' : 'neutral');
              const active = mobileOpen && mobileOpen.name == tile.name;
              return (
                <button type="button" key={tile.name}
                  className={'mobile-kpi mobile-kpi-' + level + (active ? ' mobile-kpi-active' : '')}
                  disabled={count == 0}
                  onClick={() => this.openPanel(tile.name)}>
                  <i className={'fa ' + tile.icon} />
                  <span className="mobile-kpi-count">{count}</span>
                  <span className="mobile-kpi-label">{tile.label}</span>
                </button>
              );
            })}
          </div>

          {mobileOpen && tableMap[mobileOpen.name].length > 0 &&
            <div className="mobile-kpi-list">
              <div className="mobile-kpi-list-header">
                <b>{mobileOpen.label}</b>
                <button type="button" className="btn btn-default btn-sm" onClick={() => this.openPanel(mobileOpen.name)}>
                  <i className="fa fa-times" />
                </button>
              </div>
              <SyncProductsTable params={this.props.params} edit={true} products={tableMap[mobileOpen.name]} style="primary" type={typeMap[mobileOpen.name]} panel={mobileOpen.name} />
            </div>
          }
        </div>

        <div className="hidden-xs">
          <Row>
            {sortedColumns.map(columnName => {
              const column = {
                name: columnName,
                label: headerMap[columnName], // Utilisez un objet de mappage pour obtenir les libellés
                table: tableMap[columnName], // Utilisez un objet de mappage pour obtenir les tables
                bsStyle: bsStyleMap[columnName], // Utilisez un objet de mappage pour obtenir les styles Bootstrap
                type: typeMap[columnName] // Utilisez un objet de mappage pour obtenir les types
              };

              return (
                <Col key={column.name} className={this.props.dashboardOptions[column.name].open ? 'col-xs-12 col-md-12' : 'col-xs-12 col-md-4'}>
                  <Panel bsStyle={column.bsStyle} header={column.label} collapsible expanded={this.props.dashboardOptions[column.name].open} style={{ overflow: 'hidden', minHeight: column.table.length > 0 ? '142px' : 'auto' }}>
                    {column.table.length > 0 && (
                      <SyncProductsTable params={this.props.params} edit={true} products={column.table} style="primary" type={column.type} panel={column.name} />
                    )}
                  </Panel>
                </Col>
              );
            })}
          </Row>
        </div>



         {/*<div>
                    {column.table.length > 0 && (
                      <SyncProductsTable
                        params={this.props.params}
                        edit={true}
                        products={column.table}
                        style="primary"
                        type={column.type}
                        panel={column.name}
                      />
                    )}
                  </Panel>
                </Col>
              ))
            }
          </Row>
                    
        </div>
    
    
       <div>
        <Row>
          <Col className={openProducts.open ? 'col-xs-12 col-md-12 ' : 'col-xs-12 col-md-4 '} >
            <Panel bsStyle="primary" header={header5} collapsible expanded={openProducts.open} style={{ overflow: 'hidden', 'minHeight': '142px' }}>
              <SyncProductsTable params={this.props.params} edit={true} products={productTable} style="primary" type="normal" panel="openProducts" />
            </Panel>
          </Col>

          <Col className={openPannes.open ? 'col-xs-12 col-md-12 ' : 'col-xs-12 col-md-4 '} >
            <Panel bsStyle="danger" header={header2} collapsible expanded={openPannes.open} style={{ overflow: 'hidden', 'minHeight': '142px' }}>
              {pannesTable.length > 0 &&
                <SyncProductsTable params={this.props.params} edit={true} products={pannesTable} style="primary" type='pannes' panel="openPannes" />
              }
            </Panel>
          </Col>


          <Col className={openUsagers.open ? 'col-xs-12 col-md-12 ' : 'col-xs-12 col-md-4 '} >
            <Panel bsStyle="danger" header={header8} collapsible expanded={openUsagers.open} style={{ overflow: 'hidden', 'minHeight': '142px' }}>
              <SyncProductsTable params={this.props.params} edit={true} products={usager_products} style="primary" type='usager' panel="openUsagers" />
            </Panel>
          </Col>

        </Row>

        <Row>
          <Col className={openDisactivated.open ? 'col-xs-12 col-md-12 ' : 'col-xs-12 col-md-4 '} >
            <Panel bsStyle="warning" header={header4} collapsible expanded={openDisactivated.open} style={{ overflow: 'hidden', 'minHeight': '142px' }}>
              {disactivatedTable.length > 0 &&
                <SyncProductsTable params={this.props.params} edit={true} products={disactivatedTable} style="primary" type='indisponible' panel="openDisactivated" />
              }
            </Panel>
          </Col>

          <Col className={openTravaux.open ? 'col-xs-12 col-md-12 ' : 'col-xs-12 col-md-4 '} >
            <Panel bsStyle="warning" header={header7} collapsible expanded={openTravaux.open} style={{ overflow: 'hidden', minHeight: travauxTable.length > 0 ? '142px' : 'auto' }}>
              {travauxTable.length > 0 &&
                <SyncProductsTable params={this.props.params} edit={true} products={travauxTable} style="primary" type='travaux' panel="openTravaux" />
              }
            </Panel>
          </Col>




          <Col className={openCyclical.open ? 'col-xs-12 col-md-12 ' : 'col-xs-12 col-md-4 '} >
            <Panel bsStyle="warning" header={header9} collapsible expanded={openCyclical.open}
              style={{ overflow: 'hidden', 'minHeight': '142px' }}>
              <div > 

                <div>
                  {cyclicalTable.length > 0 &&
                    <SyncProductsTable
                      params={this.props.params}
                      edit={true} products={cyclicalTable}
                      style="primary" type='cyclical'
                      panel="openCyclical"
                    />
                  }
                </div>

              </div>



            </Panel>
          </Col>




        </Row>

                </div>*/}
        </div>)
  }
}


function createRow(p, style) {

  return (<tr>
    <td>{p.identification_ID}</td>
    <td>{p.groups}</td>
    <td>{p.localisation_adresse}</td>
    <td>
      <LinkContainer to={'/client/product/' + p.id + '/edit'}>
        <button className={"btn btn-" + style}>
          <i className="fa fa-pencil" />
        </button>
      </LinkContainer>
    </td>
  </tr>)
}


function genHeader(array, t) {
  if (array.length > 0) {

    return <div style={{ fontSize: '17px' }}>({array.length} {t("main.sheets")})</div>

  } else {
    return <div style={{ fontSize: '17px' }}>({t("main.no_sheets")})</div>
  }

}

function createTable(rows) {

  return (

    <table className="table table-striped">
      <tr>
        <th>ID</th>
        <th>Groupe(s)</th>
        <th>Adresse</th>
        <th>Action</th>
      </tr>

      {rows}

    </table>


  )

}